exports.onRouteUpdate = require("./gatsby/browser/onRouteUpdate")
